import { SET_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE } from './../../actions/actionTypes';

const initialState = {
    isCustomErrorOpen: false,
    errorMessage: '',
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR_MESSAGE:
      return { ...state, isCustomErrorOpen: true,errorMessage: action.payload };
    case CLEAR_ERROR_MESSAGE:
      return { ...state,isCustomErrorOpen: false, errorMessage: '' };
    default:
      return state;
  }
};

export default alertReducer;